<script setup lang="ts">
  import Departments from './departments/index.vue'

  definePage({
    meta: {
      layout: 'admin',
      adminRoute: true,
    },
  })
</script>

<template>
  <Departments />
</template>

<style scoped lang="scss">
  .home-page {
    &__container {
      flex-wrap: wrap;
      gap: 16px;
    }
    &__combined-cells {
      gap: 16px;
    }
  }
</style>
